// extracted by mini-css-extract-plugin
export default {"Table":"styles_Table__BJYjS","empty":"styles_empty__y7nb+"};